import { BC_API_BASE_URL } from "./apiConfig";

export function clearLocalStorageItem(key) {
  if (localStorage.getItem(key)) {
    localStorage.removeItem(key);
    console.log(`Item with key "${key}" has been removed from localStorage.`);
  } else {
    console.log(`Item with key "${key}" does not exist in localStorage.`);
  }
}

export function clearLocalStorageLists() {
  const customersUrl = BC_API_BASE_URL + `/customers`;
  const itemsUrl = BC_API_BASE_URL + `/items`;
  const quotesUrl = BC_API_BASE_URL + `/salesquotes`;

  if (localStorage.getItem(customersUrl)) {
    localStorage.removeItem(customersUrl);
    console.log(
      `Item with key "${customersUrl}" has been removed from localStorage.`
    );
  } else {
    console.log(
      `Item with key "${customersUrl}" does not exist in localStorage.`
    );
  }

  if (localStorage.getItem(itemsUrl)) {
    localStorage.removeItem(itemsUrl);
    console.log(
      `Item with key "${itemsUrl}" has been removed from localStorage.`
    );
  } else {
    console.log(`Item with key "${itemsUrl}" does not exist in localStorage.`);
  }

  if (localStorage.getItem(quotesUrl)) {
    localStorage.removeItem(quotesUrl);
    console.log(
      `Item with key "${quotesUrl}" has been removed from localStorage.`
    );
  } else {
    console.log(`Item with key "${quotesUrl}" does not exist in localStorage.`);
  }
}
